<template>
  <v-dialog
    v-model="active"
    class="nx-login-page ma-0"
    persistent
    lazy
    content-class="ma-0 fill-height elevation-0 v-dialog--fullscreen"
  >
    <div class="fill-height">
      <v-container class="nx-login-page fill-height">
        <v-layout
          align-center
          column
          fill-height
          justify-center
        >
          <v-flex>
            <v-layout
              align-center
              fill-height
              justify-center
            >
              <nx-auth-login-page-router
                v-if="pageId"
                :page-id="pageId"
                @redirect="setPage"
              />
            </v-layout>
          </v-flex>

          <v-flex
            v-if="recoverMail"
            shrink
          >
            <v-sheet
              class="nx-login-page__problems py-3 px-4 elevation-3"
              v-html="$t('message.login.problems', { mail: recoverMail })"
            />
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </v-dialog>
</template>

<script>
import NxAuthLoginPageRouter from '@/modules/authentication/components/AuthLoginPageRouter.vue';
import { getDefaultLoginPageId } from '@/modules/authentication/config/login-pages';
import config from '@/modules/authentication/config';

export default {
  name: 'NxAuthModal',
  components: { NxAuthLoginPageRouter },
  data() {
    return {
      pageId: null,
    };
  },
  computed: {
    active() {
      return !this.$store.getters['authentication/staffIsLogged'];
    },
    recoverMail() {
      return config.loginContactWithUsMailAddress;
    },
  },
  watch: {
    active() {
      if (!this.active) {
        this.pageId = getDefaultLoginPageId();
      }
    },
  },
  mounted() {
    this.pageId = getDefaultLoginPageId();
  },
  methods: {
    setPage(loginPageId) {
      this.pageId = loginPageId;
    },
  },
};

</script>
